import { staticConnectionStatus } from 'state/network/status';
import { fetch } from 'utils/network';
import { startTrace } from 'utils/performance/trace';

import GroqError, { IGroqError } from '../exceptions/groq-error';

export type GroqArgs<A extends object> = {} & A;

export interface IGroqResponse<R extends object> {
  error: IGroqError;
  ms: number;
  query: string;
  result: R;
}

export const groqQuery = <R extends object, V extends object>(
  url: string,
  query: string,
  { ...params }: GroqArgs<V> = {} as GroqArgs<V>,
  { loggingTag }: { loggingTag: string }
) => {
  const trace = startTrace(`groq_op_${loggingTag}`);

  // always use POST since groq handles caching for POST too with a hash
  return fetch<R, {}>(url + `?tag=${loggingTag}`, {
    body: JSON.stringify({ params, query, returnQuery: false }),
    headers: {
      'Content-Type': 'application/json',
    },
    maxRetries: 3,
    method: 'POST',
    connection: staticConnectionStatus.current,
    then: (res: IGroqResponse<R>) => {
      if (res.error) {
        throw new GroqError(res.error);
      }
      return res.result;
    },
  }).finally(() => {
    trace?.stop();
  });
};
